import { render, staticRenderFns } from "./GoodsDoing.vue?vue&type=template&id=b24f5f46&scoped=true&"
import script from "./GoodsDoing.vue?vue&type=script&lang=js&"
export * from "./GoodsDoing.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDoing.vue?vue&type=style&index=0&id=b24f5f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24f5f46",
  null
  
)

export default component.exports